import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { NOTIFY } from 'src/app/core/constants/notification.constants';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { UtilService } from 'src/app/core/services/util.service';
import { ValidationService } from 'src/app/core/services/validation.service';

@Component({
  selector: 'app-delete-application-dialog',
  templateUrl: './delete-application-dialog.component.html',
  styleUrls: ['./delete-application-dialog.component.scss']
})
export class DeleteApplicationDialogComponent {

  appId: string = "";
  interalForm
  options = [
    "Incorrect Certification Pathway Selected",
    "Didn't meet all requirements",
    "Decided not to apply at this time",
    "Other"
  ]

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public util: UtilService,
    public dialogRef: MatDialogRef<DeleteApplicationDialogComponent>,
    public appWizService : AppWizService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.appId = data.appId;
    this.interalForm = this.fb.group({
      deleteReason: new FormControl("", [Validators.required]),
      deleteComment : new FormControl({ value: '', disabled: true })
    });
  }

  requestApplicationDelete() {
    this.appWizService.deleteApp(this.interalForm.value)
    .subscribe({
      next: ()=>{
        this.router.navigate(['app']);
        this.closeDialog();
      },
      error: (err) => {
        console.log(err);
        this.util.openToastr('error',NOTIFY.APPLICATION_DELETE.FAILED)
      }
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  changeValidation() {
    if (this.interalForm?.get('deleteReason')?.value !== this.options[this.options.length-1]) {
      this.interalForm.controls['deleteComment'].setValidators([]);
      this.interalForm.controls['deleteComment'].disable();
    } else {
      this.interalForm.controls['deleteComment'].setValidators([Validators.required, Validators.minLength(10),ValidationService.InputcleanValidation]);
      this.interalForm.controls['deleteComment'].enable();
    }
    this.interalForm.controls['deleteComment'].updateValueAndValidity();
  }

}
